import React from 'react';
import styled from 'styled-components';

import { Body } from 'src/presentation/components/forms/Layout';
import { Button, ButtonTypes, Tooltip } from 'src/presentation/components/agent_desktop_components';
import { DropdownMenu } from 'src/presentation/components/agent_desktop_components';
import InformationIcon from '@ad-scripts/presentation/components/lib/icons/information_icon';
import { StyledDeleteButton } from 'src/presentation/components/pages/shared/DeleteButton';

export const StyledBody = styled(Body)`
  max-width: 700px;
`;

export const StyledDropdown = styled(DropdownMenu)`
  margin-left: ${p => (p.leftMargin ? '12px' : '0')};
  margin-right: ${p => (p.rightMargin ? '12px' : '0')};
  width: 220px;
`;

export const StyledRowWrapper = styled.div`
  margin-bottom: 18px;
`;

export const StyledEntityRow = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 0;

  &:hover {
    ${StyledDeleteButton} {
      visibility: visible;
    }
  }
`;

export const StyledRowItem = styled.div`
  margin-right: 12px;
`;

export const PaddedRowItem = styled.div`
  margin-right: 28px;
`;

export const StyledTypeDescription = ({ children }) => {
  if (!children || !children.length) return null;
  return <DescriptionButton disabled>{children}</DescriptionButton>;
};

const DescriptionButton = styled(Button).attrs({ buttonType: ButtonTypes.SECONDARY })`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: space-between;
  margin-right: 12px;
  min-height: 34px;

  &[disabled] {
    background: ${p => p.theme.colors.gray100};
    color: ${p => p.theme.colors.gray900};
  }
`;

export const StyledConditionLabel = styled(DescriptionButton)`
  display: block;
  justify-content: center;
  max-width: 280px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-right: 3px;
`;

export const StyledInformationIcon = styled(InformationIcon)`
  cursor: pointer;
  fill: ${p => p.theme.colors.gray600};
  height: 15px;
  margin-right: ${p => p.theme.spacing.small};
  width: 15px;
`;

export const StyledOperatorDropdown = styled(StyledDropdown)`
  width: 130px;
`;

export const StyledOperatorLabel = styled.span`
  width: 50px;
  margin-right: 8px;
`;
